module.exports = __webpack_public_path__ + "static/img/avatar.ec1e39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = 14
// module chunks = 0